import { IKnmErknmFormApproveRemark } from '../../MainModule/interfaces/IKnmErknmFormApproveRemark';
import { approveRemarkToString } from './approveRemarkToString';

export const approveRemarksToNote = (remarks: IKnmErknmFormApproveRemark[] | undefined): string =>
  remarks
    ?.map(approveRemarkToString)
    .filter(item => !!item)
    .map((item, index) => `${index + 1}. ${item};`)
    .join('\n') || '';
